/* eslint-disable id-match */
export const APP_READY = 'Acs.AppReady';
export const WIDGET_READY = 'Acs.WidgetReady';
export const SET_JOB_CHAT_ID = 'Acs.SetJobChatId';
export const SET_JWT = 'Acs.SetJWT';
export const RENDER_WIDGET = 'Acs.RenderWidget';
export const OPEN_WIDGET = 'Acs.OpenWidget';
export const CLOSE_WIDGET = 'Acs.CloseWidget';
export const USER_INPUT_ACTION = 'Acs.UserInputAction';
export const UPDATE_CONFIG = 'Acs.UpdateConfig';
export const MINIMIZE_MENU = 'Acs.MinimizeMenu';
export const SET_OR_UPDATE_BADGE = 'Acs.SetOrUpdateBadge';
export const FOCUS_CHAT = 'Acs.FocusChat';
